import type { IconType, MenuItem } from '@graftcode/design-system'

export function isFluentIconValue(icon: MenuItem['icon']): icon is IconType {
  return typeof icon === 'string'
}
